/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { ChartType } from '@models/chart.model';
import { ChartsIcons } from '@functions/chart.functions';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-option',
  templateUrl: './widget-option.component.html',
  styleUrls: ['./widget-option.component.css']
})
export class WidgetOptionComponent {

  @Input() label: string;
  @Input() color: string = ItemColor('widgets');
  @Input() sublabel: string;
  @Input() categories: string[];
  @Input() information: string;
  @Input() subinformation: string;
  @Input() dark: number = 5;
  @Input() limitedTo: ChartType[] = [];

  icons = ChartsIcons();

  constructor() {}

}
